<template>
    <div class="agent-container">
        <h2 class="page-title"> 인증 내역 AI 조회         </h2>

        AI 질문 예시 <br>

        1. 월간 국가별/도시별 인증 순위를 알려줘 <br>
        2. 연간 국가별/도시별 인증 순위를 알려줘 <br>
        3. 월간 10회 초과 인증현황을 순위대로 국가별/도시별로 알려줘 <br>
        4. 연간 10회 초과 인증현황을 순위대로 국가별/도시별로 알려줘 <br>


        <!-- 질문 입력 영역 -->
        <el-card class="section-card" shadow="always">
            <div class="input-row">
                <el-input
                    v-model="question"
                    placeholder="예: 이번 달에 대여된 건수는 몇 건이야?"
                    clearable
                    @keyup.enter="askAgent"
                    size="medium"
                    class="input-text"
                />

                <el-button type="primary" @click="askAgent" :loading="loading">
                    AI 질의하기
                </el-button>
            </div>
        </el-card>

        <!-- 결과 영역 -->
        <div v-if="response" class="result-wrap">
            <el-card class="section-card" shadow="hover">

                <div class="field-block">
                    <p class="label">📝 질문</p>
                    <div class="field">{{ response.question }}</div>
                </div>

                <div class="field-block">
                    <p class="label">🧩 생성된 SQL</p>
                    <pre class="sql-box">{{ response.sql }}</pre>
                </div>

                <div class="field-block">
                    <p class="label">📋 결과</p>

                    <el-table
                        v-if="response.result && response.result.length"
                        :data="response.result"
                        border
                        size="small"
                        class="result-table"
                    >
                        <el-table-column
                            v-for="(value, key) in response.result[0]"
                            :key="key"
                            :prop="key"
                            :label="key"
                            align="center"
                        />
                    </el-table>

                    <div v-else class="empty-msg">(결과 없음)</div>
                </div>

            </el-card>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    name: "BorrowHistAgent",
    data() {
        return {
            question: "",
            response: null,
            loading: false,
        };
    },
    methods: {
        async askAgent() {
            if (!this.question.trim()) {
                this.$message.warning("질문을 입력하세요.");
                return;
            }

            this.loading = true;
            this.response = null;

            try {
                const res = await axios.post(this.$url + "/authInfo/query", {
                    question: this.question,
                    rfidGetOrderSeq: this.$store.state.rfid_get_order_seq,
                });

                this.response = res.data;
            } catch (err) {
                console.error(err);
                this.$message.error("AI 요청 중 오류가 발생했습니다.");
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
<style scoped>
/* 전체 컨테이너 */
.agent-container {
    max-width: 900px;
    margin: 30px auto;
    padding: 10px;
}

/* 제목 */
.page-title {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 25px;
}

/* 카드 공통 */
.section-card {
    padding: 20px;
    background: #fafafa;
    border-radius: 10px;
}

/* 입력 영역 */
.input-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.input-text {
    flex: 1;
}

/* 결과 영역 공통 */
.result-wrap {
    margin-top: 25px;
}

.field-block {
    margin-bottom: 25px;
}

.label {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

/* 일반 필드 */
.field {
    background: #ffffff;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 14px;
    border: 1px solid #ddd;
}

/* SQL 코드 블록 */
.sql-box {
    background: #1e1e1e;
    color: #dcdcdc;
    padding: 12px;
    border-radius: 6px;
    font-size: 13px;
    white-space: pre-wrap;
    margin-bottom: 10px;
}

/* 테이블 */
.result-table {
    margin-top: 10px;
}

/* 결과 없음 */
.empty-msg {
    margin-top: 10px;
    color: #888;
    text-align: center;
    font-size: 14px;
}
</style>

